import React from 'react';
import Localize from 'react-intl-universal';

import { Formik, Form } from 'formik';
import { omit } from 'lodash-es';

import Button from '@mui/material/Button';

import { participantsOptions, AdditionalAddressTypes } from '@pages/BookingProcess/Constants';
import AdditionalAddress from '@pages/BookingProcess/ContactInformation/AdditionalAddress';
import useCreateSchema from '@pages/BookingProcess/ContactInformation/useCreateSchema';
import { getInitContactInformation } from '@pages/BookingProcess/hooks/useBookingProcess';

import CreateDialogForm from './CreateDialogForm';

const ParticipantDialogForm = ({
  configuration = {},
  inputRef,
  setOpen,
  setParticipants,
  formData,
  mode,
  setIsFormValid,
  participantId,
  isCreateNewParticipant = true,
  isShowInterest = false,
  showInterestSubmit = () => {},
  isEventFree = false,
  isEventIlias
}) => {
  const participantValidationSchema = useCreateSchema(true, isEventFree);

  const onSubmit = (values) => {
    if (mode === 'edit') {
      setParticipants((participants) => {
        const copy = [...participants];
        const index = participants.findIndex((participant) => participant.id === formData.id);

        if (index !== -1) {
          const participantName = `${values.generalInformation?.firstName || ''} ${values?.generalInformation?.lastName || ''}`;
          copy[index] = { ...copy[index], ...values };
          if (participants[index].additionalInfo) {
            copy[index] = {
              ...copy[index],
              additionalInfo: { ...participants[index].additionalInfo, name: participantName }
            };
          }

          if (participants[index].discounts) {
            copy[index] = {
              ...copy[index],
              discounts: { ...participants[index].discounts, name: participantName }
            };
          }

          return copy;
        } else {
          copy[index] = { ...copy[index], ...values };
        }
      });
    } else {
      setParticipants((prev) => [
        ...prev,
        {
          ...values,
          id: participantId,
          isBookingPerson: values?.isBookingPerson === participantsOptions.bookingPerson
        }
      ]);
    }
    setOpen(false);
  };

  return (
    <>
      <Formik
        validateOnMount
        enableReinitialize={true}
        initialValues={
          mode === 'edit'
            ? formData
            : omit(getInitContactInformation(isEventFree), 'billingAddress', 'billingAddressRadio')
        }
        validationSchema={participantValidationSchema}
        onSubmit={isShowInterest ? showInterestSubmit : onSubmit}
      >
        {({ handleSubmit, values }) => (
          <>
            <Form>
              <CreateDialogForm
                configuration={configuration}
                setIsFormValid={setIsFormValid}
                bookingPersonForm={false}
                isCreateNewParticipant={isCreateNewParticipant}
                isEventFree={isEventFree}
                isEventIlias={isEventIlias}
              />
              {!isShowInterest && (
                <AdditionalAddress
                  addressConfig={AdditionalAddressTypes.Communication}
                  values={values}
                  isEventFree={isEventFree}
                />
              )}
            </Form>
            <Button
              aria-hidden='true'
              sx={{ visibility: 'hidden' }}
              onClick={handleSubmit}
              ref={inputRef}
            >
              {Localize.get('Booking.saveParticipant')}
            </Button>
          </>
        )}
      </Formik>
    </>
  );
};
export default ParticipantDialogForm;
